<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">INTRODUCTION</p>
<p class="noindent">You may be asking, “Who was Emerson Carey?” That is a good question, and it took a whole book to answer it. He was a pioneering man who stuck to his principles, worked hard and found great success. Carey was a Kansas industrialist, philanthropist, state senator, shrewd businessman and accomplished golfer, but what made him a Reno County icon was his creation of the Carey Salt Company in Hutchinson, Kansas.</p>
<p class="indent">Our interest in Carey comes from the fact that we help operate the Reno County Museum and Strataca-Kansas Underground Salt Museum. The Salt Museum is housed underground in the very salt mine that Carey created. Writing this book has increased our knowledge of Carey’s industries and the man himself. We were amazed at the sheer number of companies, industries, interests and philanthropic activities in which Emerson Carey was involved. Each one could be a book on its own. Carey had four sons who also were quite accomplished and led admirable lives; a book about each son could easily be written as well.</p>
<p class="indent">We chose to follow Carey’s life chronologically, from birth to death. Because he was involved in so many things simultaneously throughout his life, it was extremely difficult to include all the particulars in every industry and activity. It was our goal to show just how complicated and involved Carey’s life was. It is of note that although his achievements left long-lasting legacies that still thrive today, the book itself ends at his death.</p>
<p class="indent">So, travel back in time with us, to a cold winter day in a log cabin in Indiana at the beginning of 1863… </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Introduction.vue?7f49dbc2